import React, { useEffect, useState } from "react";
import { Application } from "@/api/applications";
import RigthPanel from "@/ui-controls/RigthPanel";
import DeleteApplicationForm from "@/components/applications/DeleteApplicationForm";

interface Props {
  application: Application | undefined;
  onDelete: (application: Application) => any;
  onClose: () => any;
}

const DeleteApplication = (props: Props) => {
  useEffect(() => {
    setIPanelOpen(props.application !== undefined);
  }, [props.application]);

  const onCloseDeleteAppPanel = () => {
    setIPanelOpen(false);
    if (props.onClose) props.onClose();
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <RigthPanel
        header="Delete Application"
        isOpen={isPanelOpen}
        dismissPanel={onCloseDeleteAppPanel}
        childComponent={DeleteApplicationForm}
        childProps={{
          application: props.application,
          onClose: () => onCloseDeleteAppPanel(),
          onDelete: (app: Application) => {
            props.onDelete(app);
            onCloseDeleteAppPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default DeleteApplication;
